import { render } from "./WriteOffRecordTable.vue?vue&type=template&id=14580053"
import script from "./WriteOffRecordTable.vue?vue&type=script&lang=js"
export * from "./WriteOffRecordTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__